import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";

const SubHeader = ({ headerData }) => {
  const navigate = useNavigate();
  const location = useLocation(); 

  const hasData = headerData?.details?.data && headerData.details.data.length > 0;


const isSelected = (route) => location.pathname.includes(`/${route}/`) || location.pathname.endsWith(`/${route}`) ;


  return (
    <div className="w-full flex flex-col  transition-colors duration-300">
      
      {/* Scrollable Sub-Navigation Bar */}
      <div className="w-full border-b border-border   ">
        <nav 
          dir="rtl" 
          // Hides the scrollbar while keeping it scrollable
          className=" flex items-center gap-2 px-3 py-1 overflow-x-auto whitespace-nowrap  max-w-[1400px]  w-full"
        >
          {hasData && headerData.details.data
            .filter((v) => Number(v.hidden) < 1)
            .map((item, i) => {
              
              // Check if this button is the active route
             

              return (
                <button
                  key={i}
                  onClick={() => navigate(item.to)}
                  className={`
                    flex items-center gap-2 px-5 py-2.5 rounded-full font-bold text-sm md:text-base 
                    ${isSelected(item.to) 
                      ? "bg-brand-light text-brand-primary  shadow-md" 
                      : "bg-bg-tertiary text-foreground   hover:bg-bg-secondary"
                    }
                  `}
                >
                  {/* Icon - Defaults to a generic widget icon if item.icon is missing */}
                  <Icon 
                    icon={item.icon || "solar:widget-5-bold-duotone"} 
                    className={`text-lg md:text-xl transition-colors duration-300 ${
                      isSelected(item.to) ? "text-brand-primary" : "text-text-primary"
                    }`}
                  />
                  <span>{item.label}</span>
                </button>
              );
            })}
        </nav>
      </div>

      {/* Renders the nested routes below the nav */}
      <div className="flex-grow bg-background">
        <Outlet />
      </div>
      
    </div>
  );
};

export default SubHeader;